import {Component} from 'react';
import injectSheet from 'react-jss';

import {ControlGroup} from '-/components/fields/Control';
import {center, important, rem, size, standardFont} from '-/styles/utils';

const styles = theme => ({
    root: {
        background: theme.colors.error,
        border: '1px solid #d6d6d6',
        borderRadius: 5,
        '& span, & p': {
            border: 'none !important',
            display: 'inline-block',
            fontFamily: '$font-family',
            fontSize: 14,
            fontWeight: 'normal',
            lineHeight: 19,
            color: theme.colors.strong,
            padding: 10,
            marginLeft: 15
        }
    },
    icon: {
        display: 'inline-block',
        margin: '0 5px 0 0'
    },
    ul: {
        border: important('none'),
        fontSize: 14,
        fontWeight: 'normal',
        lineHeight: 19,
        color: theme.colors.strong,
        padding: 10,
        marginLeft: 15
    },
    error: {
        ...size('20px'),
        '&::before, &:before': {
            content: '"\\f071"',
            display: 'block',
            fontFamily: 'FontAwesome',
            fontWeight: 'normal',
            color: 'white'
        }
    },
    li: {
        listStyle: 'none',
        ...standardFont(),
        color: 'white'
    }
});

class FieldErrors extends Component {
    render() {
        const {messages = [], classes = {}} = this.props;

        return (
            <ControlGroup>
                <div className={classes.root}>
                    <ul className={classes.ul}>
                        {messages.map((msg, i) => {
                            return (
                                <li key={i} className={classes.li}>
                                    <div className={classes.icon}>
                                        <div className={classes.error} />
                                    </div>
                                    {msg}
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </ControlGroup>
        );
    }
}

export default injectSheet(styles)(FieldErrors);